import styled from 'styled-components';

import {
  Button,
} from 'web-components';
import {
  Flex,
} from 'web-styled';

import TextInput from 'web-components/TextInput';

export const Search = styled(Flex).attrs({
  column: true,
  align: 'center',
  justify: 'center',
})`
  position: relative;
  width: 100%;
`;

export const Input = styled(TextInput)`
  color: #2f3539;
  height: 38px;
  border-radius: 20px;
`;

export const SearchButton = styled(Button).attrs({
  type: 'submit',
  appearance: 'link',
})<{ active: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  width: 38px;
  height: 38px;
  color: ${props => (props.active ? props.theme.colors.primary : '#999')}
`;
